<template>
    <div class="boyixuetang-page">
        <!-- 顶部Header组件 -->
        <Header />

        <div class="content-wrapper">
            <!-- 导航路径 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'home' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>学堂详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 文章内容区域 -->
            <div class="article-content">
                <!-- 文章标题 -->
                <h1 class="article-title">{{ articles.title }}</h1>

                <!-- 文章信息 -->
                <div class="article-info">
                    <!-- <span class="info-item">4211 阅读</span> -->
                    <span class="info-item">{{ articles.create_time }}</span>
                </div>

                <!-- 文章正文 -->
                <div class="article-body">
                    <div class="paragraph" v-html="articles.content">
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部Footer组件 -->
        <Footer />
    </div>
</template>

<script>
// 导入Header和Footer组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'

export default {
    name: 'BoyiXuetangPage',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            // 页面数据
            aid: this.$route.query.aid,
            articles: {}
        }
    },
    mounted() {
        // 页面加载时调用方法
        this.getBoyixuetangDetail();
    },
    methods: {
        // 页面方法
        // 获取博弈学堂详情
        getBoyixuetangDetail() {
            this.$api.getBoyixuetangDetail({
                article_id: this.aid
            }).then(res => {
                this.articles = res;
            }).catch(err => {
                this.$message.error(err);
            })
        }
    }
}
</script>

<style scoped>
.boyixuetang-page {
    min-height: 100vh;
    background-color: #f5f7fa;
}

.content-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.breadcrumb {
    padding: 24px 0 20px 0;
}

/* 文章内容区域样式 */
.article-content {
    background-color: #fff;
    padding: 40px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.article-title {
    font-size: 28px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: center;
}

.article-info {
    text-align: center;
    color: #666;
    font-size: 14px;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
}

.info-item {
    margin: 0 15px;
}

.article-body {
    line-height: 1.8;
    color: #333;
}

.paragraph {
    margin-bottom: 20px;
    font-size: 16px;
}

.article-image {
    text-align: center;
    margin: 30px 0;
}

.article-image img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
}

.section-title {
    font-size: 22px;
    font-weight: bold;
    color: #333;
    margin: 30px 0 20px;
}

.prevention-list {
    margin: 20px 0;
    padding-left: 25px;
}

.prevention-list li {
    margin-bottom: 15px;
    font-size: 16px;
}
</style>